import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { Helmet } from 'react-helmet';

import AdminTitleBar from 'Parts/common/AdminTitleBar';
import TaxReceiptAdminConfigurationPanel from '../components/TaxReceiptAdminConfigurationPanelContainer';
import TaxReceiptAdminHistoryPanel from '../components/TaxReceiptAdminHistoryPanelContainer';
import ResponsiveTabs from 'Parts/ui/components/ResponsiveTabs';
import Can from 'Parts/session/components/CanContainer';

import TaxReceiptAdminPage_en from './locales/TaxReceiptAdminPage_en.json';
import TaxReceiptAdminPage_fr from './locales/TaxReceiptAdminPage_fr.json';

class TaxReceiptAdminPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      historyPermissions: null
    };

    i18next.addResourceBundle('en', 'TaxReceiptAdminPage', TaxReceiptAdminPage_en);
    i18next.addResourceBundle('fr', 'TaxReceiptAdminPage', TaxReceiptAdminPage_fr);
  }

  componentDidMount() {
    this.setState({
      historyPermissions: this.props.checkAuthorization({ platform: this.props.platform.id }, [
        'platform.plugin.taxReceipt.config.logs'
      ])
    });
  }

  componentDidUpdate() {
    if (this.state.historyPermissions === null) {
      const authorization = this.props.checkAuthorization({ platform: this.props.platform.id }, [
        'platform.plugin.taxReceipt.config.logs'
      ]);

      if (typeof authorization === 'boolean') {
        this.setState({
          historyPermissions: authorization
        });
      }
    }
  }

  render() {
    const { props, state } = this,
      { t, platform, locale } = props,
      { historyPermissions } = state;

    const tabPages = [
      {
        title: t('Configuration'),
        slug: 'configuration',
        container: () => (
          <Can
            rules={[
              'permissions.platform.plugin.taxReceipt.config.get',
              'permissions.platform.plugin.taxReceipt.config.update'
            ]}
            platformId={platform.id}
            redirect={`/${locale}/d`}
          >
            <TaxReceiptAdminConfigurationPanel {...props} />
          </Can>
        )
      },
      {
        title: t('LOGS:History'),
        slug: 'history',
        visible: historyPermissions,
        container: () => <TaxReceiptAdminHistoryPanel {...props} />
      }
    ];

    return (
      <div className="TaxReceiptAdminPage">
        <Helmet>
          <title>{t('Donation receipts')}</title>
        </Helmet>
        <AdminTitleBar title={t('Donation receipts')} />
        <ResponsiveTabs pages={tabPages} parentPage={props} defaultTabHasNoSlug />
      </div>
    );
  }
}

TaxReceiptAdminPage.defaultProps = {
  permissions: {
    platform: {
      plugin: {
        taxReceipt: null
      }
    }
  }
};

export default translate('TaxReceiptAdminPage')(TaxReceiptAdminPage);
